// Module
var code = "<form class=\"basket-checkout\" action=\"{{actionUrl}}\" method=\"post\"> <input type=\"hidden\" value=\"\" name=\"token\"/> <input type=\"hidden\" value=\"Checkout-Begin\" name=\"action\"/> <button type=\"submit\" role=\"button\" class=\"basket-checkout__button jbr-btn--yellow\">[[Checkout]]</button> </form>";
// Exports
module.exports = code;